import { render, staticRenderFns } from "./CallReporting.vue?vue&type=template&id=636bbba9&scoped=true"
import script from "./CallReporting.vue?vue&type=script&lang=js"
export * from "./CallReporting.vue?vue&type=script&lang=js"
import style0 from "./CallReporting.vue?vue&type=style&index=0&id=636bbba9&prod&lang=scss&scoped=true"
import style1 from "./CallReporting.vue?vue&type=style&index=1&id=636bbba9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636bbba9",
  null
  
)

export default component.exports